import * as Actions from 'reducks/error/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const ErrorReducer = (state = initialState.error, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_PASSWORD_ERROR:
      return {
        ...state,
        confirm_password: action.payload,
      }
    case Actions.EMAIL_ERROR:
      return {
        ...state,
        email: action.payload,
      }
    case Actions.PASSWORD_ERROR:
      return {
        ...state,
        password: action.payload,
      }
    case Actions.STRIPE_ERROR:
      return {
        ...state,
        stripe: action.payload,
      }
    case Actions.INIT_ERROR:
      return {
        ...initialState.error,
      }
    default:
      return state
  }
}
